/* eslint-disable max-len */
const ru = {
  nav: {
    home: 'главная',
    chats: 'чаты',
    profile: 'профиль',
    adminPanel: 'админ-панель',
    logout: 'выйти',
    login: 'вход',
    register: 'регистрация',
  },
  theme: {
    label: 'тема',
    light: 'светлая тема',
    dark: 'тёмная тема',
  },
  language: {
    label: 'язык',
    en: 'Английский',
    ru: 'Русский',
  },
  common: {
    cancel: 'отмена',
    confirm: 'подтвердить',
    close: 'закрыть',
    submit: 'отправить',
    save: 'сохранить',
    delete: 'удалить',
    accept: 'принять',
    reject: 'отклонить',
    leave: 'выйти',
    remove: 'удалить',
    ok: 'ок',
    loading: 'загрузка...',
    online: 'в сети',
    offline: 'не в сети',
    email: 'email',
    password: 'пароль',
    code: 'код',
    name: 'имя',
    confirmPassword: 'повтор',
    unknownError: 'неизвестная ошибка',
    errorPrefix: 'ошибка: {message}',
    on: 'вкл',
    off: 'выкл',
  },
  validation: {
    passwordRequired: 'пароль обязателен',
    passwordMinLength: 'пароль должен быть не короче 8 символов',
    passwordNeedNumber: 'пароль должен содержать хотя бы одну цифру',
    passwordNeedLower: 'пароль должен содержать хотя бы одну строчную букву',
    passwordNeedUpper: 'пароль должен содержать хотя бы одну заглавную букву',
    usernameCharset: 'имя может содержать только латинские буквы (a-z, A-Z), цифры (0-9), подчёркивания (_) и дефисы (-) без пробелов и других символов',
    emailRequired: 'email обязателен',
    emailInvalid: 'введите корректный email',
    passwordsMismatch: 'пароли не совпадают',
    emailAndPasswordRequired: 'email и пароль обязательны',
    defaultError: 'произошла ошибка',
  },
  home: {
    subtitle: 'приватный чат, голосовые комнаты, сквозное шифрование',
    featureChatTitle: 'чат',
    featureChatDesc: 'обмен сообщениями с контактами и в группах в реальном времени',
    featureCallTitle: 'звонок',
    featureCallDesc: 'прямые аудиозвонки с вашими контактами',
    featureRoomsTitle: 'голосовые комнаты',
    featureRoomsDesc: 'групповые голосовые пространства — заходите в любой момент',
    featureE2eTitle: 'e2e-шифрование',
    featureE2eDesc: 'сообщения и голос читаются только на ваших устройствах',
    openChats: 'открыть чаты',
    signIn: 'войти',
    signUp: 'зарегистрироваться',
    version: 'версия {version}',
  },
  login: {
    title: 'вход',
    twoFaTitle: 'введите код 2FA',
    signIn: 'войти',
    forgotPassword: 'забыли пароль?',
    enterAuthenticator: 'введите код из приложения-аутентификатора, чтобы завершить вход',
    successRedirect: 'вход выполнен, перенаправление...',
    loginFailed: 'ошибка, вход не выполнен',
    enter2faCode: 'введите код 2FA',
    twoFaSuccess: '2FA подтверждён, выполняется вход...',
    signInError: 'ошибка входа, проверьте данные',
    verify2faError: 'ошибка проверки 2FA, проверьте код',
  },
  register: {
    title: 'регистрация',
    signUp: 'зарегистрироваться',
    usernameHint: 'имя (буквы, цифры, _ и -, сгенерируется само, если пусто)',
    passwordHint: 'пароль не короче 8 символов, с цифрами, заглавными и строчными буквами',
    signUpError: 'ошибка регистрации: {message}',
  },
  forgotPassword: {
    title: 'восстановление пароля',
    codeSent: 'код сброса пароля отправлен на ваш email',
    checkEmail: '{message}. проверьте почту и перейдите на страницу сброса пароля.',
    redirecting: 'перенаправление...',
  },
  resetPassword: {
    title: 'сброс пароля',
    newPassword: 'новый пароль',
    enterEmailAndCode: 'введите email и код сброса',
    enterNewPassword: 'введите новый пароль и подтверждение',
    passwordsMismatch: 'пароли не совпадают',
    updated: 'пароль успешно обновлён',
    didNotReceive: 'не получили код?',
    resendIn: 'не получили код? повторная отправка через {seconds} с',
    resend: 'отправить снова',
    sending: 'отправка...',
  },
  activation: {
    registrationSuccess: 'регистрация успешна',
    activateTitle: 'активируйте аккаунт',
    enterCodeTitle: 'введите код активации',
    activatedTitle: 'аккаунт успешно активирован',
    accountCreated: 'ваш аккаунт создан',
    codeSentTo: 'код активации отправлен на {email}',
    checkInbox: 'проверьте почту и введите код ниже',
    redirectingLogin: 'перенаправление на страницу входа...',
    didNotReceive: 'не получили код?',
    activate: 'активировать',
    activating: 'активация...',
    resend: 'отправить снова',
    sending: 'отправка...',
    enterCode: 'введите код активации',
    enterEmail: 'введите email',
    notActivated: 'аккаунт не активирован — введите код из письма или запросите новый',
    activationError: 'ошибка активации, попробуйте ещё раз',
  },
  twoFa: {
    title: 'двухфакторная аутентификация',
    intro1: 'используйте приложение-аутентификатор как второй фактор (2FA)',
    intro2: 'при входе потребуется код безопасности из приложения-аутентификатора',
    intro3: 'если вы используете приложение для 2FA, распространённые варианты можно',
    intro4: 'найти в магазине приложений: Google Authenticator, LastPass Authenticator, Microsoft Authenticator, Authy и др.',
    enabled: '2FA включена',
    disabled: '2FA выключена',
    disable: 'отключить 2FA',
    setup: 'настроить 2FA',
    exit: 'выйти',
    scanQr: 'отсканируйте этот qr-код',
    activate: 'активировать',
    disabledSuccess: 'двухфакторная аутентификация отключена',
    enterCode: 'введите код подтверждения',
    loadError: 'ошибка загрузки статуса 2FA. попробуйте ещё раз',
    setupError: 'ошибка настройки 2FA. попробуйте ещё раз',
    verifyError: 'ошибка проверки. проверьте код и попробуйте снова',
    disableError: 'ошибка отключения 2FA. попробуйте ещё раз',
  },
  notFound: {
    message: 'упс! страница, которую вы ищете, не существует',
    goHome: 'вернуться на главную',
  },
  profile: {
    loading: 'загрузка профиля...',
    title: 'профиль пользователя',
    connectId: 'connect_id',
    twoFa: '2FA',
    e2e: 'e2e',
    twoFaTooltip: 'Двухфакторная аутентификация — при входе нужен второй код',
    e2eTooltip: 'Сквозное шифрование — сообщения читаете только вы и собеседник',
    manage2fa: 'управление двухфакторной аутентификацией',
    setup2fa: 'настроить двухфакторную аутентификацию',
    sessions: 'сессии',
    changeName: 'изменить имя',
    changePassword: 'изменить пароль',
    deleteAccount: 'удалить аккаунт',
    changeAvatar: 'сменить аватар',
    removeAvatar: 'удалить аватар',
    copyConnectId: 'скопировать connect_id',
    copied: 'скопировано!',
    deleteTitle: 'удалить аккаунт',
    deleteWarning: 'это действие необратимо. будет безвозвратно удалено:',
    deleteChats: 'все ваши чаты и сообщения',
    deleteSessions: 'все активные сессии',
    deleteProfile: 'информация вашего профиля',
    confirmationCode: 'код подтверждения',
    confirmDelete: 'подтвердить удаление',
    deleting: 'удаление аккаунта...',
    username: 'имя пользователя',
    usernameRules: 'только буквы, цифры, _ и -',
    updatePasswordTitle: 'обновить пароль',
    currentPassword: 'текущий пароль',
    newPassword: 'новый пароль',
    confirmNewPassword: 'подтвердите новый пароль',
    updatePassword: 'обновить пароль',
    passwordHint: 'пароль не короче 8 символов, с цифрами, заглавными и строчными буквами',
    uploadAvatar: 'загрузить аватар',
    selectImage: 'выберите изображение (макс. 5 МБ)',
    passwordUpdated: 'пароль успешно обновлён',
    nameUpdated: 'имя успешно обновлено',
    usernameTaken: 'это имя пользователя уже занято',
  },
  admin: {
    brand: 'ADMIN',
    summary: '{users} польз. · {online} онлайн · {live} в эфире',
    searchUsers: 'поиск пользователей',
    noUsers: 'нет пользователей',
    colName: 'имя',
    colEmail: 'email',
    colStatus: 'статус',
    unnamed: 'без имени',
    disable: 'отключить',
    enable: 'включить',
    reset2fa: 'сбросить 2fa',
    kickSession: 'сбросить сессии',
    resetCode: 'код сброса',
    banEmail: 'забанить email',
    delete: 'удалить',
    ban: 'бан',
    unban: 'разбан',
    end: 'завершить',
    bannedEmails: 'забаненные email',
    liveCalls: 'активные звонки',
    emailToBan: 'email для бана',
    noBanned: 'нет забаненных email',
    noLiveCalls: 'нет активных звонков',
    statusAdmin: 'админ',
    statusActive: 'активен',
    statusDisabled: 'отключён',
    statusBanned: 'забанен',
    statusOnline: 'онлайн',
    confirmReset2fa: 'сбросить 2fa для {name}?',
    confirmKick: 'сбросить все сессии {name}?',
    confirmBan: 'забанить {email}? доступ будет закрыт, повторная регистрация невозможна',
    confirmDelete: 'удалить {name} и забанить {email}?',
    confirmEndCall: 'завершить этот звонок?',
    actionFailed: 'действие не выполнено',
    endCallFailed: 'не удалось завершить звонок',
    resetCodeNotice: 'код сброса пароля для {email}: {code} (1 час)',
  },
  workspace: {
    selectChat: 'выберите чат',
    selectChatHint: 'выберите беседу в боковой панели или начните новую',
    voiceCall: 'голосовой звонок',
    startVoiceRoom: 'начать голосовую комнату',
    joinVoiceRoom: 'войти в голосовую комнату',
    endCall: 'завершить звонок',
    busyInCall: 'занято другим звонком',
    backToChats: 'назад к чатам',
    voiceRoomInCall: 'голосовая комната · {count} в звонке',
    join: 'войти',
    typeMessage: 'напишите сообщение...',
    maxCharacters: 'Максимум {count} символов',
  },
  sidebar: {
    chats: 'чаты',
    chatsMenu: 'меню чатов',
    createChat: 'создать чат',
    createGroup: 'создать группу',
    chatInvites: 'приглашения в чат',
    groupInvites: 'приглашения в группу',
    groupInfo: 'о группе',
    trustUser: 'доверие',
    deleteChat: 'удалить чат',
    deleteGroup: 'удалить группу',
    noChats: 'Нет доступных чатов',
    favorites: 'избранное',
  },
  chat: {
    favorites: 'избранное',
    group: 'группа',
    membersCount: '{count} участников',
    statusHidden: 'статус скрыт',
    groupInfo: 'о группе',
    copyText: 'копировать текст',
    deleteForEveryone: 'удалить (у всех)',
    textCopied: 'текст скопирован',
    noContacts: 'нет контактов',
  },
  voice: {
    record: 'записать голосовое',
    send: 'отправить голосовое',
    cancel: 'отменить голосовое',
    play: 'играть',
    pause: 'пауза',
    encrypted: 'зашифрованное голосовое',
    micDenied: 'нет доступа к микрофону',
    startFailed: 'не удалось начать запись',
    notSupported: 'голосовые сообщения здесь не поддерживаются',
  },
  modals: {
    createChatInvite: 'приглашение в чат',
    connectId: 'connect ID',
    sendInvite: 'отправить',
    chatInvites: 'приглашения в чат',
    incoming: 'входящие',
    outgoing: 'исходящие',
    noIncoming: 'нет входящих приглашений',
    noOutgoing: 'нет исходящих приглашений',
    createGroup: 'создать группу',
    groupName: 'название группы',
    selectMembers: 'выберите участников из контактов',
    noContactsYet: 'пока нет контактов — сначала начните чат',
    groupInvites: 'приглашения в группу',
    invitedBy: 'пригласил(а) {name}',
    noGroupInvites: 'нет приглашений в группу',
    groupInfo: 'о группе',
    members: 'участники',
    pending: 'ожидают',
    confirmRemove: 'подтвердить?',
    pendingInvites: 'ожидающие приглашения',
    showAdmin: 'показать панель админа',
    hideAdmin: 'скрыть панель админа',
    renameGroup: 'переименовать группу',
    saveName: 'сохранить имя',
    sendInvites: 'отправить приглашения',
    dangerZone: 'опасная зона',
    deleteGroupEveryone: 'удалить группу для всех',
    deleteChat: 'удалить чат',
    deleteGroup: 'удалить группу',
    onlyForMe: 'только у меня',
    leaveGroup: 'покинуть группу',
    forEveryone: 'у всех',
    deleteMessage: 'удалить сообщение',
    deleteMessageConfirm: 'удалить это сообщение у всех?',
    trustPeer: 'доверие к собеседнику',
    selectAll: 'выбрать всё',
    shareAvatar: 'показывать аватар',
    shareEmail: 'показывать email',
    shareStatus: 'показывать статус',
    shareAvatarDesc: 'собеседник видит ваш аватар',
    shareEmailDesc: 'собеседник видит ваш email',
    shareStatusDesc: 'собеседник видит ваш статус онлайн',
    activeSessions: 'активные сессии',
    thisDevice: 'Это устройство',
    activeDevices: 'Активные устройства',
    terminateOthers: 'Завершить все другие сессии',
    terminateSession: 'Завершить сессию',
  },
  call: {
    incoming: 'входящий звонок',
    accept: 'принять звонок',
    reject: 'отклонить звонок',
    dismiss: 'закрыть',
    unknownUser: 'неизвестный пользователь',
    connected: 'соединено',
    calling: 'вызов...',
    connecting: 'подключение...',
    voiceCall: 'голосовой звонок',
    mute: 'выкл. микрофон',
    unmute: 'вкл. микрофон',
    shareScreen: 'демонстрация экрана',
    stopSharing: 'остановить демонстрацию',
    minimize: 'свернуть',
    expand: 'развернуть',
    exitFullscreen: 'выйти из полноэкранного режима',
    leave: 'выйти',
    endCall: 'завершить звонок',
    endForEveryone: 'завершить звонок для всех',
    peers: 'участники',
    screen: 'экран',
    noiseSuppression: 'шумоподавление (RNNoise)',
    yourScreen: 'ваш экран',
    missed: 'пропущенный звонок',
    noAnswer: 'без ответа',
    declined: 'отклонён',
    incomingCall: 'входящий звонок',
    outgoingCall: 'исходящий звонок',
    groupCall: 'групповой звонок',
  },
  system: {
    newChatInvite: 'новое приглашение в чат',
    inviteDeclined: 'ваше приглашение в чат отклонено',
    inviteAccepted: 'приглашение в чат принято',
    chatRestored: 'чат восстановлен',
    chatDeleted: 'чат удалён',
    newMessage: 'у вас новое сообщение',
    chatActivityUpdated: 'активность чата обновлена',
    newGroupInvite: 'новое приглашение в группу',
    closeNotification: 'закрыть уведомление',
    requestOne: '1 запрос',
    requestMany: '{count} запросов',
  },
  notify: {
    groupInviteAccepted: 'приглашение в группу принято',
    groupInviteRejected: 'приглашение в группу отклонено',
    groupCreated: 'группа создана, приглашения отправлены',
    membersInvited: 'участники приглашены',
    groupRenamed: 'группа переименована',
    leftGroup: 'вы покинули группу',
    trustSaved: 'настройки доверия сохранены',
    messageDeleted: 'сообщение удалено',
    chatDeleted: 'чат удалён',
    peerOffline: 'собеседник не в сети',
    finishCallFirst: 'сначала завершите текущий звонок',
  },
  time: {
    today: 'сегодня',
    yesterday: 'вчера',
    monthDay: '{day} {month}',
    months: {
      0: 'января',
      1: 'февраля',
      2: 'марта',
      3: 'апреля',
      4: 'мая',
      5: 'июня',
      6: 'июля',
      7: 'августа',
      8: 'сентября',
      9: 'октября',
      10: 'ноября',
      11: 'декабря',
    },
  },
};

export default ru;
